module.exports = __webpack_public_path__ + "static/media/gal7.d72b94b1.jpeg";